import React, { useContext } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { FormattedMessage, useIntl } from "react-intl"
import { Link, Typography } from "@carrotfertility/carotene-core"
import { Link as RouterLink } from "react-router-dom"
import { CarrotCardCostSharePreAuthContext } from "../../state/CarrotCardCostSharePreAuthContext"
import { useFilteredAndFormattedReimbursementJourneyOptions } from "#/components/get-reimbursed/shared/reimbursementJourneys"
import { FormSelectOption } from "@carrotfertility/carotene-core-x"
import { SelectWithTileStep } from "#/components/carrot-card-cost-share/steps/variants/SelectWithTileStep"
import { Paths } from "#/utils/Paths"
import { JourneyTypes } from "#/components/get-reimbursed/steps/ExpenseJourneyTypes"
import { MetabolicCareRequirementsBox } from "#/components/carrot-card-cost-share/steps/shared/MetabolicCareRequirementsBox"

export function WhatIsExpenseRelatedToStep(): JSX.Element {
  const intl = useIntl()
  const { send } = useStateMachine()
  const {
    dispatchFormState,
    formState: { journeyType }
  } = useContext(CarrotCardCostSharePreAuthContext)

  const allOptions: FormSelectOption[] = useFilteredAndFormattedReimbursementJourneyOptions()
  const filteredAndFormattedReimbursementJourneyOptions: FormSelectOption[] = allOptions.filter(
    (option) => option.value !== JourneyTypes.PATHFINDING
  )

  function onSubmit(formValues: { [key: string]: string }): void {
    if (formValues.journeyType !== journeyType) {
      dispatchFormState({ type: "RESET_STATE" })
    }
    dispatchFormState({ type: "UPDATE_FIELD", field: "journeyType", value: formValues.journeyType })
    send(formValues.journeyType)
  }

  return (
    <SelectWithTileStep
      title={intl.formatMessage({ defaultMessage: "What is this expense related to?" })}
      description={
        <Typography>
          <FormattedMessage
            defaultMessage="If you're not sure or don't see something listed, <link>contact us</link>."
            values={{
              link: (linkContent) => (
                <Link
                  component={RouterLink}
                  to={Paths.CARE_TEAM}
                  color="inherit"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {linkContent}
                </Link>
              )
            }}
          />
        </Typography>
      }
      selectName="journeyType"
      options={filteredAndFormattedReimbursementJourneyOptions}
      onSubmit={onSubmit}
      defaultValue={journeyType}
    >
      <MetabolicCareRequirementsBox name="journeyType" />
    </SelectWithTileStep>
  )
}
